

















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Place from '@/dto/deliveries/Place'
import CalculateStore from '@/stores/CalculateStore'

@Component({
  inheritAttrs: false,
})
export default class PlaceSelectOption extends Vue {
  @Prop(String) query: string
  @Prop(Object) place: Place

  get isCity(): boolean {
    return this.place.type === 'г'
  }

  get isActive(): boolean {
    return CalculateStore.place
      ? this.place.id === CalculateStore.place.id
      : false
  }

  get name(): string {
    if (this.place.byZip) {
      return `<span class="query-entry">${this.query}</span> • ${this.place.name}`
    }

    return `${this.place.name
      .toLowerCase()
      .replace(this.query, `<span class="query-entry">${this.query}</span>`)}`
  }

  get description(): string {
    return [this.place.region, this.place.district]
      .filter(str => !!str)
      .join(' • ')
  }
}
